/** All copy for the public /contact page. */

export const RAAS_EMAIL = 'raas@thredup.com';
export const RAAS_MAILTO = `mailto:${RAAS_EMAIL}`;

export const NEWSROOM_HREF = 'https://newsroom.thredup.com/news';
// "The Resale Rundown" — the newsletter now lives on LinkedIn, so subscription
// management happens entirely there. Hardcoded for now; see the open question in
// the handover about making it admin-editable.
export const LINKEDIN_NEWSLETTER_HREF =
  'https://www.linkedin.com/newsletters/the-resale-rundown-7493429592515399680';

export const HERO_EYEBROW = 'Contact us';
export const HERO_LEDE =
  "Whether you're scoping a program, or exploring what resale could do for your brand, our RaaS team is one email away.";

export const EMAIL_CARD = {
  kicker: 'Email us',
  title: 'Reach the RaaS team directly.',
  body: 'Looking for guidance on resale strategy, ROI, or program setup? We’d love to help!',
  hours: 'We typically reply within one business day.',
  /** Hover/focus hints on the address and its copy button. */
  mailtoHint: 'Open your email app to send us an email',
  copyHint: 'Copy our email address',
  copiedLabel: 'Email address copied'
} as const;

export const NEWSLETTER_CARD = {
  kicker: 'NEWSLETTER',
  title: 'The Resale Rundown',
  body: 'ThredUp RaaS\'s newsletter spotlighting how leading brands turn resale into community, revenue, & loyalty.',
  // The CTA names the destination because the click leaves the site — and the
  // visitor may hit LinkedIn's login wall, which an unlabelled "Subscribe"
  // would make look like a broken form.
  ctaLabel: 'Subscribe on LinkedIn'
} as const;

export const NEWSROOM_CARD = {
  kicker: 'Newsroom',
  title: 'In the Press',
  body: 'Announcements, brand partnership launches, and the data behind the resale movement, all in one place.',
  ctaLabel: 'Visit the newsroom'
} as const;
